import html from 'text!modules/jquery.dualLevelSelectorTemplate.html';
import $ from 'jquery';
import 'jquery-ui/ui/unique-id';

function dualLevelSelector($dualLevelSelector, customOptions) {
  const options = {
    onInit: function(selectedItems) {},
    onItemsSelected: function(selectedItems) {},
    availableItems: [],
    selectedItems: []
  };

  if (customOptions) {
    $.extend(options, customOptions);
  }

  $dualLevelSelector.html(html);
  const $container = $dualLevelSelector.find('.dual-level-selector').first();
  let selectedItems = options.selectedItems.slice(0);
  let extendedItemCode = null;
  const availableItems = options.availableItems.slice(0);
  const fonctionTop = $('.fonction-top');
  renderSelector();
  options.onInit(selectedItems);

  function renderSelector() {
    $container.uniqueId();

    const uniqueId = $container.attr('id');
    $container.html('');

    $.each(availableItems, function(i, item) {
      let subLevelHtml = '';

      if (item.subLevels && item.subLevels.length !== 0) {
        subLevelHtml = subLevelHtml.concat(
          '<div class="wrapper-sub-levels"><div class="sub-levels" data-code="' + item.code + '">'
        );
        $.each(item.subLevels, function(i, subItem) {
          subLevelHtml = subLevelHtml.concat(
            '<div class="multi-selector-item" >' +
              '<input class="multi-checkbox" data-code="' +
              subItem.code +
              '" type="checkbox" ' +
              (isSelectedItem(subItem) ? 'checked' : '') +
              ' id="' +
              uniqueId +
              '-' +
              subItem.code +
              '"/>' +
              '<div class="label-wrapper"><label for="' +
              uniqueId +
              '-' +
              subItem.code +
              '"><span class="visible-checkbox icon-checkmark" data-code="' +
              subItem.code +
              '"></span><span class="item-label">' +
              subItem.label +
              '</span></label></div></div>'
          );
        });
        subLevelHtml = subLevelHtml.concat('</div></div>');
      }

      $container.append(
        '<div class="multi-selector-item" >' +
          '<input class="multi-checkbox" data-code="' +
          item.code +
          '" type="checkbox" ' +
          (isSelectedItem(item) ? 'checked' : '') +
          ' id="' +
          uniqueId +
          '-' +
          item.code +
          '"/>' +
          '<div class="label-wrapper"><label for="' +
          uniqueId +
          '-' +
          item.code +
          '"><span class="visible-checkbox icon-checkmark ' +
          (shouldHalfCheck(item) ? 'icon-minus' : '') +
          '" data-code="' +
          item.code +
          '"></span><span class="item-label">' +
          item.label +
          '</span></label>' +
          (subLevelHtml.length !== 0
            ? '<span class="expand icon-arrow-top toggling-icon" data-code="' +
              item.code +
              '"></span>'
            : '') +
          '</div>' +
          subLevelHtml +
          '</div>'
      );
    });

    const flattenedAvailableItems = flattenAvailableItems(availableItems);

    // Expanding fields logic
    $dualLevelSelector.find('.expand').click(function() {
      const $currentExpand = $(this);
      const toExpandCode = $currentExpand.attr('data-code');
      if (extendedItemCode) {
        hideSublevels(extendedItemCode);
      }
      if (extendedItemCode === toExpandCode) {
        extendedItemCode = null;
      } else {
        showSublevels(toExpandCode);
        extendedItemCode = toExpandCode;
      }
    });

    $('.multi-selector-item').hover(function() {
      $(this)
        .addClass('toggled')
        .siblings()
        .removeClass('toggled')
        .find('.multi-selector-item')
        .removeClass('toggled');
    });

    $dualLevelSelector.find('.multi-checkbox').change(function() {
      const $currentCheckbox = $(this);
      const selectedCode = $currentCheckbox.attr('data-code');
      const checkedItem = flattenedAvailableItems.find(hasSameCode(selectedCode));
      const isChecked = $currentCheckbox.is(':checked');
      const isFonction = $currentCheckbox
        .parent()
        .parent()
        .parent()
        .hasClass('js-fonctions-moteur-liste');
      const isSubItem = $currentCheckbox
        .parent()
        .parent()
        .hasClass('sub-levels');
      handleChecking(isChecked, checkedItem, isFonction, isSubItem);
      options.onItemsSelected(selectedItems);
    });

    $dualLevelSelector.find('.multi-checkbox').on('uncheckAll', function() {
      $dualLevelSelector.find('.visible-checkbox').removeClass('icon-minus');
      selectedItems.length = 0;
      options.onItemsSelected(selectedItems);
    });
  }

  function handleChecking(isChecked, checkedItem, isFonction, isSubItem) {
    if (isItemNiveauUn(checkedItem)) {
      if (isChecked) {
        selectedItems = addItem(checkedItem, selectedItems);
        if (checkedItem.subLevels) {
          $.each(checkedItem.subLevels, function(i, subItem) {
            selectedItems = addItem(subItem, selectedItems);
            tickCheckboxByCode(subItem.code);
          });
          removeHalfTickCheckboxByCode(checkedItem.code);
        }
      } else {
        selectedItems = removeItem(checkedItem, selectedItems);
        if (checkedItem.subLevels) {
          $.each(checkedItem.subLevels, function(i, subItem) {
            selectedItems = removeItem(subItem, selectedItems);
            untickCheckboxByCode(subItem.code);
          });
          removeHalfTickCheckboxByCode(checkedItem.code);
        }
      }
    } else {
      const parentItem = findParentItem(checkedItem);
      if (isChecked) {
        selectedItems = addItem(checkedItem, selectedItems);
        if (allSubLevelAreChecked(parentItem)) {
          selectedItems = addItem(parentItem, selectedItems);
          tickCheckboxByCode(parentItem.code);
          removeHalfTickCheckboxByCode(parentItem.code);
        } else {
          halfTickCheckboxByCode(parentItem.code);
        }
      } else {
        selectedItems = removeItem(checkedItem, selectedItems);
        selectedItems = removeItem(parentItem, selectedItems);
        untickCheckboxByCode(parentItem.code);
        if (shouldHalfCheck(parentItem)) {
          halfTickCheckboxByCode(parentItem.code);
        } else {
          removeHalfTickCheckboxByCode(parentItem.code);
        }
      }
    }

    // Contrôle de l'ajout du texte dans l'input
    if (isFonction || isSubItem) {
      if (selectedItems.length <= 0 && fonctionTop.hasClass('actif')) {
        fonctionTop.removeClass('actif');
        $('.fonction-text').text('Fonctions souhaitées');
      } else {
        $('.fonction-text').text('');
        selectedItems.forEach(value => {
          const functionText = $('.fonction-text');
          functionText.text(functionText.text() + value.label + ' • ');
        });

        if (!fonctionTop.hasClass('actif')) {
          fonctionTop.addClass('actif');
        }
      }
    }
  }

  function removeItem(deletedItem, selectedItems) {
    return selectedItems.filter(function(item) {
      return deletedItem.code !== item.code;
    });
  }

  function addItem(addedItem, selectedItems) {
    const newSelectedItems = selectedItems.slice(0);
    if (newSelectedItems.findIndex(hasSameCode(addedItem.code)) === -1) {
      newSelectedItems.push(addedItem);
    }
    return newSelectedItems;
  }

  function isSelectedItem(item) {
    return selectedItems.findIndex(hasSameCode(item.code)) !== -1;
  }

  function flattenAvailableItems(items) {
    const subLevels = items
      .map(item => item.subLevels)
      .reduce((a, b) => a.concat(b), []) // flatten
      .filter(function(item) {
        return !!item;
      });
    return subLevels.concat(items);
  }

  function findParentItem(subLevelItem) {
    return availableItems.find(item => !!item.subLevels.find(hasSameCode(subLevelItem.code)));
  }

  function isItemNiveauUn(selectedItem) {
    return !!availableItems.find(hasSameCode(selectedItem.code));
  }

  function allSubLevelAreChecked(item) {
    return (
      item.subLevels.filter(function(subItem) {
        return isCodeChecked(subItem.code);
      }).length === item.subLevels.length
    );
  }

  function shouldHalfCheck(item) {
    const nbChecked = item.subLevels.filter(function(subItem) {
      return isSelectedItem(subItem);
    }).length;
    return nbChecked > 0 && nbChecked < item.subLevels.length;
  }

  function hasSameCode(lookedUpCode) {
    return function(item) {
      return parseInt(item.code) === parseInt(lookedUpCode);
    };
  }

  function tickCheckboxByCode(code) {
    $container.find("input[data-code='" + code + "']").prop('checked', true);
  }

  function untickCheckboxByCode(code) {
    $container.find("input[data-code='" + code + "']").prop('checked', false);
  }

  function halfTickCheckboxByCode(code) {
    $container.find("span.visible-checkbox[data-code='" + code + "']").addClass('icon-minus');
  }

  function removeHalfTickCheckboxByCode(code) {
    $container.find("span.visible-checkbox[data-code='" + code + "']").removeClass('icon-minus');
  }

  function isCodeChecked(code) {
    return $container.find("input[data-code='" + code + "']").prop('checked');
  }

  function hideSublevels(code) {
    $container
      .find(".sub-levels[data-code='" + code + "']")
      .parent()
      .parent()
      .removeClass('toggled');
  }

  function showSublevels(code) {
    $container
      .find(".sub-levels[data-code='" + code + "']")
      .parent()
      .parent()
      .addClass('toggled');
  }
}

// exposition sous forme de module jQuery
$.fn.extend({
  dualLevelSelector: function(customOptions) {
    return this.each(function() {
      dualLevelSelector($(this), customOptions);
    });
  }
});
export default dualLevelSelector;
